import type { PopoverProps as MuiPopoverProps } from '@mui/material';
import type { ValueOf } from '@kc-console/core';

const PopoverPlacementSet = ['left', 'top', 'right', 'bottom'] as const;

type PopoverPlacement = ValueOf<typeof PopoverPlacementSet>;

const PopoverOrigin: Record<
  PopoverPlacement,
  Pick<MuiPopoverProps, 'anchorOrigin' | 'transformOrigin'>
> = {
  top: {
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center',
    },
    transformOrigin: {
      vertical: 'bottom',
      horizontal: 'center',
    },
  },
  bottom: {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center',
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center',
    },
  },
  left: {
    anchorOrigin: {
      vertical: 'center',
      horizontal: 'left',
    },
    transformOrigin: {
      vertical: 'center',
      horizontal: 'right',
    },
  },
  right: {
    anchorOrigin: {
      vertical: 'center',
      horizontal: 'right',
    },
    transformOrigin: {
      vertical: 'center',
      horizontal: 'left',
    },
  },
};

export type { PopoverPlacement };

export { PopoverPlacementSet, PopoverOrigin };
